var map = {
	"./Graphline.png": 81,
	"./Graphline2.png": 2804,
	"./active-call-white.svg": 1866,
	"./allmail.svg": 4637,
	"./angle-left.svg": 9019,
	"./angle-right.svg": 7219,
	"./arrow-left.svg": 4210,
	"./attach_file.png": 4616,
	"./attached-img.jpg": 5315,
	"./audio.svg": 2921,
	"./bg-blur.png": 5527,
	"./bg-blur.svg": 6516,
	"./calendars-end.png": 4155,
	"./date_range.png": 2526,
	"./delete_outline.svg": 6764,
	"./draftmail.svg": 1051,
	"./enlarge.svg": 1510,
	"./fck-editor.png": 4843,
	"./forward.svg": 3122,
	"./graph-full.png": 5925,
	"./hide-password.svg": 9630,
	"./icon-User.svg": 1924,
	"./icon-archive.svg": 3257,
	"./icon-bell.svg": 3739,
	"./icon-call-white.svg": 4327,
	"./icon-clearmessage.svg": 8664,
	"./icon-close-dark.png": 3518,
	"./icon-contact-info.svg": 8940,
	"./icon-copy-link.png": 7159,
	"./icon-copy.svg": 4351,
	"./icon-delete.png": 6654,
	"./icon-delete.svg": 801,
	"./icon-doctor.svg": 118,
	"./icon-edit.png": 3907,
	"./icon-edit.svg": 4614,
	"./icon-email.svg": 1042,
	"./icon-enter.svg": 6712,
	"./icon-gogle.svg": 6223,
	"./icon-link.svg": 1323,
	"./icon-message-white.svg": 9962,
	"./icon-message.svg": 5081,
	"./icon-more-verticale.svg": 5072,
	"./icon-new-meeting.svg": 8101,
	"./icon-on-going-Video-meeting.svg": 3637,
	"./icon-onbound.svg": 1050,
	"./icon-ongoing-call-white.svg": 6762,
	"./icon-phone-dark.svg": 4423,
	"./icon-phone.svg": 5833,
	"./icon-search.svg": 6633,
	"./icon-star-message.svg": 410,
	"./icon-star.svg": 9652,
	"./icon-starfilled.svg": 7352,
	"./icon-toggle-white.svg": 4668,
	"./img-ellipse-empty.png": 9145,
	"./img-ellipse.png": 8171,
	"./img-user-v-big.jpg": 7282,
	"./img-user-v.jpg": 395,
	"./img-video-call.jpg": 5128,
	"./insert_emoticon.png": 3869,
	"./left-img-auth-with-text.png": 2760,
	"./left-img-auth.png": 5867,
	"./line-pattern.png": 4047,
	"./logo.svg": 2835,
	"./message-call.svg": 8055,
	"./message-email.svg": 9766,
	"./message-text.svg": 7099,
	"./mic-big.svg": 5336,
	"./mic.svg": 9259,
	"./mic_off.svg": 9221,
	"./more-v-big.svg": 6729,
	"./move_to_inbox.svg": 8405,
	"./padlock.svg": 5941,
	"./phone_callback.svg": 5416,
	"./phone_in_talk.svg": 8314,
	"./phone_missed.svg": 6442,
	"./screen_share.svg": 840,
	"./search-doc.svg": 8358,
	"./selectbox-arrow.png": 8910,
	"./short-arrow.svg": 3192,
	"./show-password.svg": 8825,
	"./star-gray.svg": 697,
	"./star_border.svg": 3513,
	"./three-dots.svg": 1555,
	"./trash-mail.svg": 1398,
	"./uploadicon.png": 4379,
	"./videocam-big.svg": 9818,
	"./videocam.svg": 6411,
	"./videocam_off.svg": 5436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;